// Fit technology: pills, traced lines and the detail list stay in step; lines draw in once the photo is on screen.
if (!customElements.get('bl-technology')) customElements.define('bl-technology', class extends HTMLElement {
  connectedCallback() {
    this.figure = this.querySelector('.bl-tech__figure');
    this.addEventListener('click', event => {
      const target = event.target.closest('.bl-tech__pill, .bl-tech__feature-head');
      if (target) this.show(target.closest('[data-feature]').dataset.feature, target.matches('.bl-tech__pill'));
      if (event.target.closest('[data-tech-add]')) {
        // Same action as the product's own Add To Cart: an unchosen size scrolls back to the fit picker.
        const product = document.querySelector('bl-product');
        if (product?.purchase) product.purchase(); else document.getElementById('choose-fit')?.scrollIntoView({behavior: 'smooth', block: 'center'});
      }
    });
    this.resize = new ResizeObserver(() => this.placeLeaders());
    this.resize.observe(this.figure);
    this.reveal = new IntersectionObserver(entries => {
      if (!entries[0].isIntersecting) return;
      this.figure.classList.add('is-drawn');
      this.reveal.disconnect();
    }, {threshold: .35});
    this.reveal.observe(this.figure);
  }
  disconnectedCallback() { this.resize?.disconnect(); this.reveal?.disconnect(); }
  show(index, fromPhoto) {
    this.querySelectorAll('[data-feature]').forEach(item => {
      const active = item.dataset.feature === index;
      item.classList.toggle('is-active', active);
      if (item.matches('.bl-tech__pill')) item.setAttribute('aria-pressed', String(active));
      item.querySelector?.(':scope > .bl-tech__feature-head')?.setAttribute('aria-expanded', String(active));
    });
    if (fromPhoto && matchMedia('(max-width: 767px)').matches) this.querySelector(`.bl-tech__feature[data-feature="${index}"]`)?.scrollIntoView({behavior: 'smooth', block: 'nearest'});
  }
  // Leader lines run from each traced point to the nearest edge of its label.
  placeLeaders() {
    const box = this.figure.getBoundingClientRect();
    if (!box.width) return;
    const svg = this.figure.querySelector('.bl-tech__lines');
    const scale = 1000 / Math.max(box.width, box.height);
    const offsetX = (1000 - box.width * scale) / 2, offsetY = (1000 - box.height * scale) / 2;
    this.querySelectorAll('.bl-tech__pill').forEach(pill => {
      const line = svg.querySelector(`.bl-tech__trace[data-feature="${pill.dataset.feature}"] .bl-tech__leader`);
      if (!line) return;
      const rect = pill.getBoundingClientRect();
      const ax = Number(line.getAttribute('x1'));
      const left = (rect.left - box.left) * scale + offsetX, right = (rect.right - box.left) * scale + offsetX;
      line.setAttribute('x2', String(Math.abs(ax - left) < Math.abs(ax - right) ? left : right));
      line.setAttribute('y2', String((rect.top + rect.height / 2 - box.top) * scale + offsetY));
    });
  }
});
